import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M7.52331 15L16.4767 15C16.9233 15 17.1639 14.4733 16.8727 14.133L12.792 9.36523C12.3752 8.87826 11.6248 8.87826 11.208 9.36523L7.12731 14.133C6.83609 14.4732 7.07668 15 7.52331 15Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const ArrowUpFilled = React.forwardRef(IconComponent);
ArrowUpFilled.displayName = 'ArrowUpFilled';

export { ArrowUpFilled };
